import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { DefectModel, DefectWorkplaceModel, DefectStationModel } from '@/libs/Api';
import { DefectsDataService } from '@/libs/defects/defects-data-service';
import { DefectWorkplacesDataService } from '@/libs/defects/defect-workplaces-data-service';
import { DefectStationsDataService } from '@/libs/defects/defect-stations-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const defectsStore = registerCrudStore<DefectModel, DefectModel>(
    BusinessModule.Defect,
    new DefectsDataService()
);

export const defectWorkplacesStore = registerCrudStore<DefectWorkplaceModel, DefectWorkplaceModel>(
    BusinessModule.DefectWorkplace,
    new DefectWorkplacesDataService()
);

export const defectStationsStore = registerCrudStore<DefectStationModel, DefectStationModel>(
    BusinessModule.DefectStation,
    new DefectStationsDataService()
);

